<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="tit_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="cn">荣誉资质</div>
					<div class="en">Honors & Certificates</div>
				</div>
				<div class="list_box">
					<div v-for="(value, index) in imgDataCn" :key="index" class="list_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img :src="value.image" @click="showBigImg(value.image)" />
						<div v-if="value.title" class="tit">{{ value.title }}</div>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		//
	},
	data() {
		return {
			imgDataCn: [
				{ image: require('@/assets/img_public/about/ryzz/cn/1.webp'), title: '企业资质-安全生产标准化' },
				{ image: require('@/assets/img_public/about/ryzz/cn/2.png'), title: '企业资质-高新技术企业' },
				{ image: require('@/assets/img_public/about/ryzz/cn/3.webp'), title: '企业资质-质量管理体系认证' },
				{ image: require('@/assets/img_public/about/ryzz/cn/4.webp'), title: '企业资质-中关村高新技术企业' },
				{ image: require('@/assets/img_public/about/ryzz/cn/5.webp'), title: '企业资质-专精特新' },
				{ image: require('@/assets/img_public/about/ryzz/cn/6.webp'), title: '企业资质-CA' }
			],
			imgDataEn: [
				{ image: require('@/assets/img_public/about/ryzz/en/1.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/2.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/3.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/4.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/5.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/6.webp'), title: '' },
				{ image: require('@/assets/img_public/about/ryzz/en/7.webp'), title: '' },
			]
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		width: 1264px;
		margin: 0 auto;
		padding: 100px 0;
		.list_box{
			overflow: hidden;
			padding-top: 40px;
			.list_el{
				display: inline-block;
				width: 28%;
				margin: 40px 2.5% 0 2.5%;
				padding: 30px;
				background-color: #F7F6F9;
				cursor: pointer;
				.tit{
					padding-top: 30px;
					text-align: center;
					font-size: 20px;
				}
				img{
					width: 100%;
				}
			}
		}
		.tit_box{
			text-align: center;
			.en{
				padding-top: 10px;
				font-size: 20px;
			}
			.cn{
				font-size: 38px;
			}
		}
	}
}
</style>